// smoothScroll.js

function animateScrollTo(to, duration = 600) {
  const start = window.scrollY;
  const change = to - start;
  const startTime = performance.now();

  function animate(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const ease = easeInOutQuad(progress);

    window.scrollTo(0, start + change * ease);

    if (progress < 1) {
      requestAnimationFrame(animate);
    }
  }

  function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }

  requestAnimationFrame(animate);
}

export function smoothScrollToHash(offset = 0, duration = 600) {
  const hash = window.location.hash;

  if (hash) {
    let target;
    try {
      target = document.querySelector(hash);
    } catch {
      return;
    }
    if (target) {
      const top =
        target.getBoundingClientRect().top + window.scrollY - offset;
      animateScrollTo(top, duration);
    }
  }
}

export function setupAnchorLinks(offset = 0, duration = 600) {
  const anchorLinks = document.querySelectorAll('a[href^="#"]:not([href="#"])');

  anchorLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      const href = this.getAttribute("href");
      let target;
      try {
        target = document.querySelector(href);
      } catch {
        return;
      }

      if (target) {
        e.preventDefault();

        const top =
          target.getBoundingClientRect().top + window.scrollY - offset;

        window.history.pushState(null, null, href); // URLにハッシュを追加
        animateScrollTo(top, duration);
      }
    });
  });
}
